import { SERVER_NON_FIELD_ERROR_KEY } from '../../../../constants/validation'
import {
  parseFromOldApiServer,
  parseServerValidation,
} from '../../../../utils/validation'

import { USER_PROFILE_HEADER_EDIT_SUBMIT_EXTERNAL_ID_ERROR_KEY } from './useUserProfileHeaderEditSubmit.constants'

export function getUserProfileHeaderEditSubmitErrors(responseData) {
  const parsedErrors = parseServerValidation(responseData)

  return Object.entries(parsedErrors).reduce((errors, [key, value]) => {
    // Surfaced as an inline notification; the external-contact endpoint
    // returns the key as a bare string instead of under `external_id`.
    if (
      key === USER_PROFILE_HEADER_EDIT_SUBMIT_EXTERNAL_ID_ERROR_KEY ||
      key === SERVER_NON_FIELD_ERROR_KEY
    ) {
      errors[SERVER_NON_FIELD_ERROR_KEY] = parseFromOldApiServer(value)

      return errors
    }

    errors[key] = value

    return errors
  }, {})
}
